import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiResponse, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestGetMainCategories } from "./getMainCategories.request";

const QUERY_KEY = ["category-admin", "main"];

const useGetMainCategories = (
  options?: QueryOptions<ApiResponse<Category[], []>, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  const { data: categories = [], ...rest } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: requestGetMainCategories,
    ...options
  });

  const setCategories = (newCategories: Category[]) => {
    queryClient.setQueriesData(QUERY_KEY, newCategories);
  };

  return { categories, setCategories, ...rest };
};

export default useGetMainCategories;
